import React from 'react';
import { FaPhoneAlt, FaClipboardList, FaStar, FaArrowDown, FaWhatsapp } from 'react-icons/fa';
import styles from './Hero.module.css';

const Hero = () => {
  return (
    <section id="home" className={styles.hero}>
      {/* Background Slideshow Container */}
      <ul className={styles.slideshow}>
        <li><span></span></li>
        <li><span></span></li>
        <li><span></span></li>
        <li><span></span></li>
        <li><span></span></li>
        <li><span></span></li>
      </ul>

      <div className={styles.overlay}></div>

      <div className={styles.content}>
        <div className={styles.badge}>
            <span className={styles.vegIcon}>●</span>  Pure • Fresh • Truly Homemade
        </div>

        <h1 className={styles.gujaratiHeading}>
         રાજકોટમાં પ્રથમ વખત<br />
          <span className={styles.highlightText}>અનોખા ટેસ્ટ સાથે</span> આગમન થઈ રહ્યું છે.
        </h1>

        <p className={styles.subtitle}>
          Fresh Homemade Gujarati Dishes
        </p>

        {/* <p className={styles.tagline}>
          <FaStar className={styles.starIcon} /> Pure • Fresh • Truly Homemade <FaStar className={styles.starIcon} />
        </p> */}

        <div className={styles.btnGroup}>
          <a
            href="https://wa.me/918183934567"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.primaryBtn}
          >
            <FaWhatsapp className={styles.btnIcon} /> Chat on WhatsApp
          </a>

          <a href="/menu" className={styles.secondaryBtn}>
            <FaClipboardList className={styles.btnIcon} /> View Full Menu
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={styles.scrollIndicator}>
        <div className={styles.scrollArrow}>
          <FaArrowDown />
        </div>
      </div>
    </section>
  );
};

export default Hero;